/*
  Scale · Delivery estimate
  "Order within 3h 12m and receive it Tue 6 – Thu 8 Oct"

  Calculated in the visitor's browser (so cached pages stay correct) from the
  block settings: daily cut-off hour, processing days and delivery days.
  Weekends are skipped for processing and delivery.
*/
if (!customElements.get('scale-delivery')) {
  customElements.define(
    'scale-delivery',
    class ScaleDelivery extends HTMLElement {
      connectedCallback() {
        this.cutoffHour = Number(this.dataset.cutoff);
        this.processingDays = Number(this.dataset.processing);
        this.minDays = Number(this.dataset.min);
        this.maxDays = Number(this.dataset.max);
        this.output = this.querySelector('[data-delivery-text]');

        this.render();
        this.timer = setInterval(() => this.render(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      isWeekend(date) {
        const day = date.getDay();
        return day === 0 || day === 6;
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          if (!this.isWeekend(result)) added++;
        }
        return result;
      }

      // The day the order leaves the warehouse
      shipDate(now) {
        let ship = new Date(now);
        const beforeCutoff = now.getHours() < this.cutoffHour && !this.isWeekend(now);
        if (!beforeCutoff) ship = this.addBusinessDays(ship, 1);
        return this.addBusinessDays(ship, this.processingDays);
      }

      formatDate(date) {
        const locale = document.documentElement.lang || undefined;
        return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
      }

      render() {
        const now = new Date();
        const ship = this.shipDate(now);
        const from = this.formatDate(this.addBusinessDays(ship, this.minDays));
        const to = this.formatDate(this.addBusinessDays(ship, this.maxDays));
        const dates = from === to ? from : `${from} – ${to}`;

        const cutoff = new Date(now);
        cutoff.setHours(this.cutoffHour, 0, 0, 0);
        const minutesLeft = Math.floor((cutoff - now) / 60000);

        let text;
        if (minutesLeft > 0 && !this.isWeekend(now)) {
          const time = `${Math.floor(minutesLeft / 60)}h ${minutesLeft % 60}m`;
          text = this.dataset.textCountdown.replace('[time]', `<strong>${time}</strong>`);
        } else {
          text = this.dataset.textDefault;
        }

        this.output.innerHTML = text.replace('[dates]', `<strong>${dates}</strong>`);
        this.hidden = false;
      }
    }
  );
}
